import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles({ name: 'MessageBox' })(theme => ({
	paper: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: theme.palette.background.paper,
		margin: '15px',
		padding: '30px 30px 50px 50px',
		maxWidth: '724px',
		boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12);',
		[theme.originalBreakpoints.only('xs')]: {
			width: '100%',
			maxWidth: 'unset',
			maxHeight: '100%',
			margin: '0',
			marginTop: 'auto'
		}
	},
	buttonClose: {
		marginLeft: 'auto',
		flexShrink: 0
	},
	scrollbars: {
		height: '100%',
		[theme.originalBreakpoints.up('sm')]: {
			height: 'auto',
			maxHeight: '300px'
		},
		'& .os-content-glue': {
			marginBottom: '1px !important'
		}
	},
	header: {
		fontWeight: 'bold',
		lineHeight: 1.22,
		color: theme.palette.text.primary,
		wordWrap: 'break-word',
		paddingLeft: '0',
		paddingRight: '0',
		fontSize: '30px',
		marginBottom: '26px',
		marginTop: '10px',
		[theme.originalBreakpoints.up('sm')]: {
			marginBottom: '44px',
			fontSize: '36px'
		}
	},
	buttonConfirm: {
		margin: '35px 15px 0px 15px'
	},
	content: {
		paddingRight: 20,
		fontSize: '16px',
		textAlign: 'justify',
		lineHeight: 1.63,
		'& a': {
			color: theme.palette.primary.main
		}
	}
}));
